import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import getCoreUIStore from "../../stores/core/core-ui-store";

const KhattabatLoadingBackdrop = withLiteObserverAndTheme(() => {
  const isAdminLoading = getCoreUIStore().isAdminLoading.get();

  return (
    <Backdrop
      open={isAdminLoading}
      sx={{
        color: "common.white",
        zIndex: (muiTheme) => muiTheme.zIndex.drawer + 1
      }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
});

export default KhattabatLoadingBackdrop;
